import {
    useMemo,
} from 'react'
import {
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    createRoutesConfig,
} from 'app/SkyNetRoutes/skyNetRoutes.utils'
import useCreateSkyNetDomainRoutes from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    SkyNetRoutesConfig,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'
import {
    App,
    ForecastDomains,
} from 'app/enums/domain.enums'

export default function useForecastRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const SkyNetDomainRoutes = useCreateSkyNetDomainRoutes()()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [App.Forecast],
            ShortTermForecast: {
                route: ForecastDomains.ShortTermForecasts,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        SkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
